:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._quickEditGenericThumbnail_4k2yg_7 {
  pointer-events: none; }
